import { removeLocalStorage, setLocalStorage } from 'src/util/Common';
/* eslint-disable import/prefer-default-export */
import {
  FETCH_SUCCESS,
  FETCH_ERROR,
  FETCH_START
} from 'constants/ActionTypes';

// Saga effects
import { put, takeEvery } from 'redux-saga/effects';
import fetchData from './Api';

// Load API
const fetchDataAPI = function* fetchDataAPI(data) {
  const {
    configAPI, getName, cbSuccess, cbError
  } = data;
  const { apiType, isSaveLocalStorage } = configAPI;
  try {
    const receivedData = yield fetchData(configAPI, getName);
    const { status, data } = receivedData;
    // Trường hợp status = 200 || 201
    if (status === 200 || status === 201) {
      yield put({
        type: FETCH_SUCCESS,
        data,
        apiType,
        getName
      });
      yield isSaveLocalStorage && setLocalStorage(getName, data || []);
      yield cbSuccess && cbSuccess(data);
    } else {
      // Trường hợp status >= 400 && status < = 500
      yield put({
        type: FETCH_ERROR,
        error: data,
        apiType,
        getName
      });
      yield isSaveLocalStorage && removeLocalStorage(getName);
      yield cbError && cbError(data);
    }
  } catch (error) {
    yield put({
      type: FETCH_ERROR,
      error,
      apiType,
      getName
    });
    yield isSaveLocalStorage && removeLocalStorage(getName);
    yield cbError && cbError(error);
  }
};

export const watchFetchDataAPI = function* watchFetchDataAPI() {
  yield takeEvery(FETCH_START, fetchDataAPI);
};
